//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import {parser} from "@/utils/parser";

export default {
  name: "SectionCustomSliderFirst",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    SliderWithBullets: () => import("@/components/common/SliderWithBullets"),
    Scroller: () => import("@/components/common/Scroller"),
    Section: () => import("@/components/common/Section"),
    PlaceCard: () => import("@/components/common/PlaceCard"),
    RouteCard: () => import("@/components/common/RouteCard"),
    ExcursionCard: () => import("@/components/common/ExcursionCard"),
    EventCard: () => import("@/components/common/EventCard"),
  },
  props: {
    query: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      cards: [],
      title: "",
      show: false,
      pending: true,
    };
  },
  computed: {
    ...mapGetters({
      cityId: "municipality/id"
    }),
    defaultQuery() {
      return {
        city_id: this.cityId,
        position: "main-page-first",
        lang: this.$i18n.locale,
        resolution: "micro",
        count: 100500
      };
    },
    queryParams() {
      return {
        ...this.defaultQuery,
        ...this.query
      };
    },
    gap() {
      return this.$mediaSwitch({hd: 32, sm: 8, defaultValue: 24});
    },
    columns() {
      return this.$mediaSwitch({md: 2, sm: 1, defaultValue: 3});
    }
  },
  mounted() {
    if (this.cityId) {
      this.$axios.$get(`api/sliders?${parser({
        params: this.queryParams
      })}`)
        .then((resolve) => {
          if (resolve.data.length > 0) {
            this.show = true
            const sliderId = resolve.data[0].id
            this.$axios.$get(`/api/sliders/${sliderId}?${parser({
              params: this.queryParams
            })}`)
              .then((resolve) => {
                const firstSlider = resolve.data;
                if (firstSlider) {
                  this.title = firstSlider.title || '';
                  if (firstSlider.places.length > 0) {
                    const places = firstSlider.places.map(item => {
                      return {
                        props: {...item},
                        component: "PlaceCard"
                      };
                    });
                    this.cards = [...this.cards, ...places];
                  }
                  if (firstSlider.routes.length > 0) {
                    const routes = firstSlider.routes.map(item => {
                      return {
                        props: {...item},
                        component: "RouteCard"
                      };
                    });
                    this.cards = [...this.cards, ...routes];
                  }
                  if (firstSlider.excursions.length > 0) {
                    const excursions = firstSlider.excursions.map(item => {
                      return {
                        props: {...item},
                        component: "ExcursionCard"
                      };
                    });
                    this.cards = [...this.cards, ...excursions];
                  }
                  if (firstSlider.events.length > 0) {
                    const events = firstSlider.events.map(item => {
                      return {
                        props: {...item},
                        component: "EventCard"
                      };
                    });
                    this.cards = [...this.cards, ...events];
                  }
                }
              })
              .catch(() => null)
              .finally(() =>{
                this.pending = false;
                this.cards.length > 0 ? this.show = true : this.show = false;
              })
          } else {
            this.pending = false;
          }
        })
        .catch(() => null)
    }
  }
};
